const CARD_IMAGE_WIDTH = '13em';
const HORIZONTAL_WHITE_SPACE = '4%';

export {
    CARD_IMAGE_WIDTH,
    HORIZONTAL_WHITE_SPACE,
};
